import { useMemo } from "react";
import { FinancialAccountType } from "../../common/types/financialAccount";
import { FINANCIAL_ACCOUNT_TYPE_LABEL } from "../../common/constants";
import { CustomSelect } from "../forms/CustomSelect/CustomSelect";
import { InputSize } from "../../helpers/form";

interface Props {
    value?: FinancialAccountType;
    onChange: (value: FinancialAccountType) => void;
    includeCash?: boolean;
    dropdownKey: string;
    size?: InputSize;
    readOnly?: boolean;
}

export const FinancialAccountFinancialTypeSelect: React.FC<Props> = ({
    value,
    onChange,
    includeCash,
    dropdownKey,
    size,
    readOnly,
}) => {
    const types = useMemo(() => {
        const allTypes = Object.values(FinancialAccountType);
        if (!includeCash) {
            return allTypes.filter(
                (type) => type !== FinancialAccountType.CASH,
            );
        }
        return allTypes;
    }, [includeCash]);

    const options = useMemo(
        () =>
            types.map((type) => ({
                value: type as string,
                label: FINANCIAL_ACCOUNT_TYPE_LABEL[type],
            })),
        [types],
    );

    return (
        <CustomSelect
            options={options}
            value={value}
            onSelected={(newValue) =>
                onChange(newValue as FinancialAccountType)
            }
            dropdownKey={dropdownKey}
            size={size}
            readOnly={readOnly}
        />
    );
};
